export default {
  cancellation: {
    DESC_UNKNOWN: '無效的取消政策',
    DESC_NO_CANCELLATION_AFTER_ISSUED: '票券兌換後或活動開始後不可取消。',
    DESC_UPTO_X_DAYS_BEFORE_WITH_CHARGE:
      '自預訂確認日起至參加日（{{if(P1>0)為{{P1}}天前else當日}}）當地時間{{P2}}前，{{CancellationFeeDescription}}。',
    DESC_UPTO_X_HOURS_BEFORE_WITH_CHARGE:
      '自預訂確認日起至參加時間{{P1}}小時前，{{CancellationFeeDescription}}。',
    DESC_AFTER_X_DAYS_FROM_TIME_WITH_CHARGE:
      '參加日前{{P1}}天當地時間{{P2}}之後，{{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_TIME_WITH_CHARGE:
      '參加時間{{P1}}小時前之後，{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_DAYS_WITH_CHARGE:
      '自參加日前{{P1}}天當地時間{{P2}}至{{P3}}天前當地時間{{P4}}，{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_DAYS_TO_Y_HOURS_WITH_CHARGE:
      '自參加日前{{P1}}天當地時間{{P2}}至當日當地時間{{P3}}，{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_HOURS_WITH_CHARGE:
      '自參加時間{{P1}}小時前至{{P2}}小時前，{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_HOURS_TO_0_WITH_CHARGE:
      '自參加時間{{P1}}小時前至當日當地時間{{P2}}，{{CancellationFeeDescription}}',
    DESC_BEFORE_X_DAYS_AFTER_BOOKING_WITH_CHARGE:
      '以預訂確認日為第0天計算，第{{P2}}天當地時間{{P1}}前，{{CancellationFeeDescription}}',
    DESC_BEFORE_X_HOURS_AFTER_BOOKING_WITH_CHARGE:
      '預訂確認後{{P1}}小時前，{{CancellationFeeDescription}}',
    DESC_AFTER_X_DAYS_FROM_BOOKING_WITH_CHARGE:
      '以預訂確認日為第0天計算，第{{P2}}天當地時間{{P1}}之後，{{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_BOOKING_WITH_CHARGE:
      '預訂確認後{{P1}}小時之後，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_DAYS_WITH_CHARGE:
      '以預訂確認日為第0天計算，第{{P2}}天當地時間{{P1}}至參加日前{{P4}}天當地時間{{P3}}，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_HOURS_WITH_CHARGE:
      '以預訂確認日為第0天計算，第{{P2}}天當地時間{{P1}}至參加時間{{P3}}小時前，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_HOURS_AND_X_HOURS_WITH_CHARGE:
      '預訂確認後{{P1}}小時至參加時間{{P2}}小時前，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_END_WITH_CHARGE:
      '以預訂確認日為第0天計算，第{{P2}}天當地時間{{P1}}至第{{P4}}天當地時間{{P3}}，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_HOURS_WITH_CHARGE:
      '以預訂確認日為第0天計算，第{{P2}}天當地時間{{P1}}至預訂確認後{{P3}}小時前，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_HOURS_START_AND_END_WITH_CHARGE:
      '預訂確認後{{P1}}小時至{{P2}}小時前，{{CancellationFeeDescription}}'
  },
  cancellationFeeDescription: {
    FEE_PERCENTAGE: '將收取訂單總額{{value}}%作為取消費用',
    FEE_FIXED: '將收取{{value}}作為取消費用',
    FEE_PER_PARTICIPANT: '將按每位參加者收取{{value}}作為取消費用',
    FEE_NOT_TO_BE_CANCELLED: '不可取消'
  }
};
